import React from 'react';
import { Box, useTheme } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large' | number;
  color?: string;
  forceTheme?: 'light' | 'dark';
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  color = 'auto',
  forceTheme
}) => {
  const theme = useTheme();
  // Get current theme mode or use forced theme if provided
  const isDark = forceTheme ? forceTheme === 'dark' : theme.palette.mode === 'dark';
  
  // Map size to dimensions
  const getSize = (): number => {
    if (typeof size === 'number') return size;
    
    switch(size) {
      case 'small': return 24;
      case 'large': return 48;
      case 'medium':
      default: return 36;
    }
  };
  
  const dimension = getSize();
  
  // Determine colors based on theme
  const primaryColor = isDark ? '#ffffff' : '#333333';
  const backgroundColor = isDark ? 'transparent' : 'transparent';
  
  // Use provided color or auto-select based on theme
  const fillColor = color === 'auto' ? primaryColor : color;
  
  return (
    <Box 
      sx={{ 
        width: dimension, 
        height: dimension, 
        position: 'relative', 
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor,
        borderRadius: '50%',
      }}
    >
      <svg width={dimension} height={dimension} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Fast mail icon with speed lines */}
        <g>
          {/* Speed lines */}
          <rect x="80" y="175" width="150" height="30" rx="15" fill={fillColor} />
          <rect x="80" y="245" width="150" height="30" rx="15" fill={fillColor} />
          <rect x="80" y="315" width="150" height="30" rx="15" fill={fillColor} />
          
          {/* Mail envelope */}
          <rect x="230" y="145" width="220" height="160" rx="12" stroke={fillColor} strokeWidth="24" />
          <path 
            d="M230 175L340 260L450 175" 
            stroke={fillColor} 
            strokeWidth="24" 
            strokeLinecap="round"
          />
        </g>
      </svg>
    </Box>
  );
};

export default Logo; 